import styled from 'styled-components';

import { getPurpurSpacing, purpurMedia } from '@telialt/common-theme/src/purpurSelectors';
import { STICKY_SUMMARY_HEIGHT_CSS_VARIABLE } from '@telialt/core-eshop/src/CartSummaryBox/constants';
import {
    NAVIGATION_OFFSET_CSS_VARIABLE,
    NAVIGATION_OFFSET_TRANSITION_CSS_VARIABLE,
} from '@telialt/utils/src/NavigationUtils/constants';

const SAFE_ZONE_OFFSET = '2rem';

export const StickyGalleryWrapper = styled.div`
    margin-top: ${getPurpurSpacing('150')};
    position: relative;

    ${purpurMedia('lg')`
        position: sticky;
        top: calc(var(${NAVIGATION_OFFSET_CSS_VARIABLE}) + var(${STICKY_SUMMARY_HEIGHT_CSS_VARIABLE}) + ${SAFE_ZONE_OFFSET});
        height: fit-content;
        transition: var(${NAVIGATION_OFFSET_TRANSITION_CSS_VARIABLE});
    `};
`;
